import { render } from "./LoadingFormsLarge.vue?vue&type=template&id=fb258ad6"
import script from "./LoadingFormsLarge.vue?vue&type=script&lang=js"
export * from "./LoadingFormsLarge.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__